/** Bengali UI strings (merged over English in translations.js). */
export const rawBn = {
  nav: {
    home: "হোম",
    database: "স্ক্যামার ডাটাবেস",
    recovery: "পুনরুদ্ধার প্রক্রিয়া",
    risk: "ঝুঁকি যাচাই",
    redFlags: "লাল সতর্কতা",
    education: "সচেতনতা",
    stories: "বাস্তব গল্প",
    about: "আমাদের সম্পর্কে",
    contact: "যোগাযোগ",
    legalHelp: "আইনি সহায়তা",
    reportCta: "ক্ষতির রিপোর্ট",
    mentors: "মেন্টর",
    dashboard: "ড্যাশবোর্ড",
    signIn: "সাইন ইন",
    signOut: "সাইন আউট",
  },
  common: {
    reportScam: "ক্ষতির রিপোর্ট",
    learnRecovery: "অভিযোগ প্রক্রিয়া জানুন",
    confidential: "১০০% গোপনীয়",
    readMore: "আরও পড়ুন",
    backHome: "হোমে ফিরুন",
    search: "খুঁজুন",
    verified: "যাচাইকৃত",
    anonymous: "বেনামী",
    submit: "জমা দিন",
    cancel: "বাতিল",
    requiredField: "আবশ্যক",
    check: "এখনই যাচাই",
    loading: "লোড হচ্ছে…",
    error: "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
  },
  hero: {
    eyebrow: "ভারতের প্রমাণ-ভিত্তিক আর্থিক অভিযোগ নির্দেশিকা",
    title1: "আর্থিক ক্ষতির",
    title2: "বিরুদ্ধে লড়ুন।",
    subtitle:
      "ট্রেডিং প্রতারণা থেকে ব্যাংকিং, সাইবার, বীমা, এয়ারলাইন, ভোক্তা, হাউজিং ফাইন্যান্স ও পেনশন বিরোধ — সঠিক কর্তৃপক্ষ, সঠিক প্রমাণ ও সরকারি অভিযোগ ব্যবস্থায় সঠিক পরবর্তী পদক্ষেপ।",
    reportBtn: "আর্থিক ক্ষতি রিপোর্ট করুন",
    recoveryBtn: "অভিযোগ প্রক্রিয়া জানুন",
    taglines: ["সঠিক কর্তৃপক্ষ খুঁজুন।", "সঠিক প্রমাণ প্রস্তুত করুন।", "সঠিক পদক্ষেপ নিন।"],
  },
  report: {
    title: "বেনামে রিপোর্ট করুন",
    subtitle: "আপনার পরিচয় সম্পূর্ণ গোপন থাকে। প্রকাশের আগে প্রতিটি রিপোর্ট 검토 করা হয়।",
    scamType: "ক্ষতির ধরন",
    amountLost: "ক্ষতির পরিমাণ (₹)",
    platform: "ব্যবহৃত প্ল্যাটফর্ম",
    telegram: "টেলিগ্রাম ইউজারনেম (যদি থাকে)",
    upi: "UPI ID (যদি থাকে)",
    phone: "ফোন নম্বর (যদি থাকে)",
    company: "কোম্পানি / পরামর্শদাতার নাম",
    website: "ওয়েবসাইট URL",
    description: "কী ঘটেছিল — বিস্তারিত লিখুন",
    contact: "ইমেইল (ঐচ্ছিক)",
    uploadEvidence: "প্রমাণ আপলোড",
    uploadHelp: "স্ক্রিনশট, PDF, পেমেন্ট প্রমাণ, চ্যাট এক্সপোর্ট। ফাইল প্রতি ১০MB।",
    submit: "নিরাপদে জমা দিন",
    successTitle: "রিপোর্ট জমা হয়েছে",
    successDesc: "ধন্যবাদ। ৭২ ঘণ্টার মধ্যে আমাদের দল প্রমাণ 검토 করবে। আপনার পরিচয় গোপন থাকবে।",
    disclaimer: "প্রতিটি অভিযোগের জন্য প্রমাণ প্রয়োজন। মিথ্যা রিপোর্ট প্রত্যাখ্যাত হতে পারে।",
  },
  education: {
    eyebrow: "শেখা · সুরক্ষা · পুনরুদ্ধার",
    title: "সচেতনতা কেন্দ্র",
    subtitle: "ভারতীয় বিনিয়োগকারীদের জন্য প্রতারণা সচেতনতা ও আইনি নির্দেশিকা।",
    readMinutes: "মিনিট পড়ুন",
    filterAll: "সব",
    emptyCategory: "এই বিভাগে এখনও কোনো নিবন্ধ নেই।",
  },
  blog: {
    eyebrow: "তদন্ত · গল্প · নির্দেশিকা",
    title: "ব্লগ — বাস্তব মামলা, আইনি পথ",
    subtitle: "যাচাইকৃত ভুক্তভোগীর অভিজ্ঞতা ও আইনি অভিযোগের ধাপ।",
    allStories: "সব গল্প",
    featured: "বিশেষ",
    readFull: "সম্পূর্ণ পড়ুন",
    readArticle: "সম্পূর্ণ নিবন্ধ",
    collapse: "সংকুচিত",
    emptyCategory: "এই বিভাগে এখনও কোনো নিবন্ধ নেই।",
    newBadge: "নতুন",
  },
  footer: {
    tagline: "গুজব নয়, প্রমাণ। নীরবতা নয়, সুরক্ষা।",
    sections: { platform: "প্ল্যাটফর্ম", legal: "আইনি", connect: "সংযোগ" },
    links: {
      privacy: "গোপনীয়তা নীতি",
      terms: "ব্যবহারের শর্ত",
      disclaimer: "দাবিত্যাগ",
      antiHarassment: "হয়রানি-বিরোধী নীতি",
      dataDeletion: "ডেটা মুছে ফেলার অনুরোধ",
    },
    disclaimer: "CHINTAMAT আর্থিক পরামর্শ দেয় না। পুনরুদ্ধারের গ্যারান্টি দেয় না।",
    rights: "© ২০২৬ CHINTAMAT। জনস্বার্থে প্রতারণা-বিরোধী মিশন।",
  },
  stats: {
    reports: "যাচাইকৃত অভিযোগ",
    scammers: "ট্র্যাক করা প্রতারক",
    cases: "সমাধানকৃত মামলা",
    loss: "রিপোর্টকৃত ক্ষতি",
  },
};

export const appStringsBn = {
  lang: { choose: "ভাষা বেছে নিন" },
  auth: {
    welcomeBack: "আবার স্বাগতম",
    signInSubtitle: "রিভিউ, কেস ট্র্যাক ও মেন্টর সেভ করতে সাইন ইন করুন।",
    joinTitle: "CHINTAMAT-এ যোগ দিন",
    joinSubtitle: "স্ক্যাম রিপোর্ট, আইনি সহায়তা ও মেন্টর ডিরেক্টরির জন্য অ্যাকাউন্ট তৈরি করুন।",
    email: "ইমেইল",
    password: "পাসওয়ার্ড",
    name: "পুরো নাম",
    signIn: "সাইন ইন",
    signUp: "অ্যাকাউন্ট তৈরি",
    continueGoogle: "Google দিয়ে চালিয়ে যান",
    orEmail: "অথবা ইমেইল",
    newHere: "CHINTAMAT-এ নতুন?",
    haveAccount: "ইতিমধ্যে অ্যাকাউন্ট আছে?",
    createAccount: "অ্যাকাউন্ট তৈরি",
    gotoSignIn: "সাইন ইন",
    passwordMin: "পাসওয়ার্ড কমপক্ষে ৬ অক্ষর",
    roleUser: "ব্যক্তি",
    roleUserDesc: "ট্রেডার / ভুক্তভোগী — রিপোর্ট বা গবেষণার জন্য।",
    roleMentor: "মেন্টর / শিক্ষক",
    roleMentorDesc: "কোর্স, চ্যানেল বা পেইড মেন্টরশিপ চালাই।",
    roleAdvisory: "গবেষণা বিশ্লেষক / পরামর্শ",
    roleAdvisoryDesc: "SEBI-নিবন্ধিত RIA, RA বা ফার্ম।",
    verifying: "সেশন যাচাই…",
    adminRequired: "অ্যাডমিন অ্যাক্সেস প্রয়োজন।",
  },
  dashboard: {
    eyebrow: "আমার ড্যাশবোর্ড",
    hello: "নমস্কার",
    adminPanel: "অ্যাডমিন প্যানেল",
    adminDesc: "ব্যবহারকারী, স্ক্যাম রিপোর্ট, আইনি সহায়তা ও ব্লগ পরিচালনা।",
    openAdmin: "অ্যাডমিন খুলুন",
    statReviews: "লেখা রিভিউ",
    statCases: "রিপোর্ট করা কেস",
    statLegal: "আইনি অনুরোধ",
    statSaved: "সেভ করা মেন্টর",
    tabReviews: "আমার রিভিউ",
    tabCases: "আমার কেস",
    tabSaved: "সেভ মেন্টর",
    tabLegal: "আইনি সহায়তা",
    emptyReviews: "এখনও কোনো রিভিউ নেই।",
    browseMentors: "মেন্টর দেখুন",
    emptyCases: "এখনও কোনো কেস নেই।",
    reportScam: "ক্ষতি রিপোর্ট",
    emptySaved: "কোনো সেভ মেন্টর নেই।",
    discoverMentors: "মেন্টর খুঁজুন",
    emptyLegal: "এখনও কোনো আইনি অনুরোধ নেই।",
    submitLegal: "অনুরোধ পাঠান",
    viewProfile: "প্রোফাইল দেখুন",
    recentActivity: "সাম্প্রতিক আপডেট",
    openCase: "কেস খুলুন",
    prefsTitle: "বিজ্ঞপ্তি পছন্দ",
    prefsBlog: "নতুন ব্লগ ও শিক্ষা নিবন্ধ",
    prefsCase: "কেস স্ট্যাটাস ও স্টাফ উত্তর",
    prefsSaved: "পছন্দ সংরক্ষিত",
  },
  notifications: {
    title: "বিজ্ঞপ্তি",
    empty: "এখনও কোনো বিজ্ঞপ্তি নেই",
    markAllRead: "সব পড়া হিসেবে চিহ্নিত",
    viewDashboard: "ড্যাশবোর্ড খুলুন",
    types: {
      case_status_change: { title: "{caseLabel} — স্ট্যাটাস আপডেট", body: "আপনার কেস এখন: {status}" },
      case_staff_comment: { title: "CHINTAMAT থেকে উত্তর", body: "{authorName}: {preview}" },
      case_user_comment: { title: "ব্যবহারকারীর মন্তব্য — {caseLabel}", body: "{authorName}: {preview}" },
      new_scam_report: { title: "নতুন স্ক্যাম রিপোর্ট", body: "{scamType}" },
      new_legal_request: { title: "নতুন আইনি অনুরোধ", body: "{lossType} — {name}" },
      blog_published: { title: "নতুন নিবন্ধ", body: "{articleTitle}" },
    },
  },
  caseWorkspace: {
    evidenceTitle: "প্রমাণ চেকলিস্ট",
    statusTimeline: "স্ট্যাটাস টাইমলাইন",
    comments: "মন্তব্য",
    sendMessage: "বার্তা পাঠান",
    postComment: "মন্তব্য পোস্ট",
    noComments: "এখনও কোনো মন্তব্য নেই। CHINTAMAT স্টাফ এখানে উত্তর দেবে।",
    userCommentHint: "আপনার বার্তা CHINTAMAT স্টাফ দেখতে পাবে।",
    staffCommentHint: "পাবলিক মন্তব্য ব্যবহারকারী দেখতে পায়। অভ্যন্তরীণ নোট শুধু স্টাফের।",
    publicVis: "পাবলিক (ব্যবহারকারী দেখতে পায়)",
    internalVis: "শুধু অভ্যন্তরীণ",
    loading: "কেস লোড হচ্ছে…",
    notFound: "কেস পাওয়া যায়নি",
    caseUpdated: "কেস আপডেট",
    commentPosted: "মন্তব্য পোস্ট হয়েছে",
    checklist: {
      screenshots: "চ্যাট বা স্ক্রিনশট প্রমাণ",
      payment_proof: "UPI / ব্যাংক পেমেন্ট প্রমাণ",
      platform_profile: "প্রতারক প্রোফাইল লিংক",
      contract: "ইনভয়েস বা চুক্তি",
    },
  },
  mentors: {
    title: "মেন্টর ডিরেক্টরি",
    subtitle: "পেমেন্টের আগে মেন্টর যাচাই করুন। রিভিউ নিবন্ধিত ব্যবহারকারীদের — SEBI নিবন্ধন স্বয়ং যাচাই করুন।",
    search: "নাম, কোম্পানি, শহর খুঁজুন…",
    category: "বিভাগ",
    allCategories: "সব বিভাগ",
    verification: "যাচাই",
    all: "সব",
    verifiedOnly: "শুধু যাচাইকৃত",
    unverified: "অযাচাইকৃত",
    sortTrust: "সর্বোচ্চ বিশ্বাস",
    sortReviews: "সবচেয়ে বেশি রিভিউ",
    sortRecent: "সাম্প্রতিক",
    noResults: "কোনো মেন্টর মেলেনি।",
    viewProfile: "প্রোফাইল",
    reviews: "রিভিউ",
  },
  protected: { loading: "সেশন যাচাই…", adminLoading: "অ্যাডমিন যাচাই…" },
};
